import styled from 'styled-components';
import { Input as InputMaterial } from '@material-ui/core';

export const Container = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
`;

export const Title = styled.h2`
  font-family: Poppins;
  font-size: 1.111vw;
  font-style: normal;
  font-weight: 500;
  line-height: 1.667vw;
  letter-spacing: 0em;
  text-align: left;
`;
export const Input = styled(InputMaterial)`
  font-family: Poppins;
  font-size: 1.111vw;
  font-style: normal;
  font-weight: 500;
  line-height: 1.667vw;
  letter-spacing: 0em;
  text-align: left;
  width: ${(props) => props.width};
  height: 3.333vw;

  .MuiInputBase-input {
    background: ${(props) => (props.disabled ? 'white' : '#F1F1F1')};
    padding: 0.833vw 0 0.833vw 1.215vw;
    font-family: Poppins;
    font-size: 1.111vw;
    font-style: normal;
    font-weight: 400;
    line-height: 1.667vw;
    letter-spacing: 0em;
    text-align: left;
  }
  .MuiInput-underline {
    &:before {
      background-color: #f1f1f1;
    }
  }
`;
